import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

import { Button } from '@simplywallst/ui-core';

export const TransactionsPortfolioFeedbackBanner = () => {
  const makeTypeformPopup = useTypeformDrawer('g6BdSIhV');
  return (
    <div className="grid items-center">
      <p className="text-xs text-softer">
        Have feedback on the portfolio tool?{' '}
        <Button
          className="static"
          styleType="strongLink"
          display="inline-block"
          onClick={makeTypeformPopup}
        >
          Share it here!
        </Button>
      </p>
    </div>
  );
};
